import React from 'react';
import PropTypes from 'prop-types';
import { Spacing } from 'works/legacy/lib/style-helper';
import { Colors } from '@common/tokens';

export default function OnboardingListTemplateLabel({ label }) {
  return (
    <>
      <td className="onboarding-list-template-label">{label}</td>
      <style jsx>{`
        .onboarding-list-template-label {
          padding-right: ${Spacing.baseSpacingPx};
          margin-top: 4px;
          font-size: 16px;
          color: ${Colors.midnightLighter};
        }
      `}</style>
    </>
  );
}

OnboardingListTemplateLabel.propTypes = {
  label: PropTypes.string.isRequired,
};
